import { i18nNsFactory, LANGUAGE_ENGLISH } from '@atlas-frontend/i18n';
import translations from './InfoIcon.translations.json';
import React, { useMemo } from 'react';
import { Tooltip } from './Tooltip';
import { Button } from 'antd';
import * as Icon from 'react-feather';
import { InfoIconUrl } from './InfoIconUrl';
import { useConfiguration } from '../../configuration';
import styled from 'styled-components';
import { colorGray } from '@atlas-frontend/design-tokens';
import { useCurrentLocale } from '../translations';

const { addTranslations, t } = i18nNsFactory('info');
addTranslations(translations);

export interface InfoIconProps {
  infoIconUrl?: InfoIconUrl;
}
export const InfoIcon = (props: InfoIconProps) => {
  const { infoIconUrl } = props;
  const { atlasDocsUrl } = useConfiguration();
  const language = useCurrentLocale();
  const url = useMemo(() => {
    if (language !== LANGUAGE_ENGLISH) {
      return `${atlasDocsUrl}/${language}${infoIconUrl}`;
    } else {
      return `${atlasDocsUrl}${infoIconUrl}`;
    }
  }, [atlasDocsUrl, infoIconUrl, language]);
  return (
    <Tooltip wrapperType="div" title={t('tooltip')}>
      <StyledButton
        id="bookmark-create"
        href={url}
        disabled={!infoIconUrl}
        target="_blank"
        icon={<Icon.Info size={20} color={colorGray[6]} />}
      />
    </Tooltip>
  );
};

const StyledButton = styled(Button)`
  background-color: transparent !important;
  box-shadow: none !important;
  border: none;
  span {
    height: 20px;
  }
`;
